const getFilterPreviousDefectData = (params) => {
  const { defectData, trailerDefect, tractorDefect, dollyDefect } = params;
  const {
    updatedTrailerDefectList,
    updatedTractorDefectList,
    updatedDollyDefectList,
  } = defectData;
  let [newTrailerDefectList, newTractorDefectList, newDollyDefectList] = [
    trailerDefect,
    tractorDefect,
    dollyDefect,
  ];
  if (updatedTrailerDefectList.length !== 0) {
    newTrailerDefectList = [
      ...trailerDefect.filter(
        (defect) =>
          defect.equipNumber !== updatedTrailerDefectList[0]?.equipNumber,
      ),
      ...updatedTrailerDefectList,
    ];
  }
  if (updatedTractorDefectList.length !== 0) {
    newTractorDefectList = [
      ...tractorDefect.filter(
        (defect) =>
          defect.equipNumber !== updatedTractorDefectList[0]?.equipNumber,
      ),
      ...updatedTractorDefectList,
    ];
  }
  if (updatedDollyDefectList.length !== 0) {
    newDollyDefectList = [
      ...dollyDefect.filter(
        (defect) => defect.equipNumber !== updatedDollyDefectList[0]?.equipNumber,
      ),
      ...updatedDollyDefectList,
    ];
  }

  return {
    newTrailerDefectList,
    newTractorDefectList,
    newDollyDefectList,
  };
};

const getMappedDefectData = (defectData, equipmentNumber) => {
  if (!defectData || defectData.length === 0) {
    return [];
  }
  return defectData.reduce((acc, equipItem) => {
    if (!equipItem?.defects || equipItem?.defects?.length === 0) {
      return acc;
    }
    acc = [
      ...acc,
      ...equipItem.defects.map((defect) => ({
        ...defect,
        equipNumber: equipItem[equipmentNumber],
      })),
    ];
    return acc;
  }, []);
};

export { getFilterPreviousDefectData, getMappedDefectData };
